export const ELEMENT_IDS = {
  CIRCULAR_PROGRESS_BAR: 'a11y-circular-progress-bar',
  COMPANY_NAVIGATION: 'a11y-company-navigation',
  PLANNING_EVALUATION_NAVIGATION: 'a11y-real-estate-navigation',
  CONTACT_SIDEBAR: 'a11y-contact-sidebar',
  MAIN_NAVIGATION: 'a11y-main-navigation',
  SUB_NAVIGATION: 'a11y-sub-navigation',
};
